var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoFilmMusicLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 2.75H20.1668M1.8335 8.25H10.0835M1.8335 13.75H7.3335M1.8335 19.25H5.50016",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8533 20.1666C11.3833 20.1666 11.8916 19.9561 12.2663 19.5813C12.6411 19.2065 12.8516 18.6982 12.8516 18.1683C12.8516 17.6383 12.6411 17.13 12.2663 16.7552C11.8916 16.3805 11.3833 16.1699 10.8533 16.1699C10.3233 16.1699 9.81504 16.3805 9.44028 16.7552C9.06552 17.13 8.85498 17.6383 8.85498 18.1683C8.85498 18.6982 9.06552 19.2065 9.44028 19.5813C9.81504 19.9561 10.3233 20.1666 10.8533 20.1666Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 16.839V9.03819C20.1666 7.37902 19.1216 7.14986 18.0674 7.43402L14.0799 8.52486C13.3557 8.72652 12.8516 9.29486 12.8516 10.129V18.1682",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8516 12.4666L20.1666 10.4683M18.1682 18.8374C18.6982 18.8374 19.2065 18.6269 19.5813 18.2521C19.956 17.8774 20.1666 17.3691 20.1666 16.8391C20.1666 16.3091 19.956 15.8008 19.5813 15.4261C19.2065 15.0513 18.6982 14.8408 18.1682 14.8408C17.6382 14.8408 17.13 15.0513 16.7552 15.4261C16.3804 15.8008 16.1699 16.3091 16.1699 16.8391C16.1699 17.3691 16.3804 17.8774 16.7552 18.2521C17.13 18.6269 17.6382 18.8374 18.1682 18.8374Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoFilmMusicLight);
export default __webpack_public_path__ + "static/media/photo-film-music-light.254403eeaa5ffb26e2f983bb51e03253.svg";
export { ForwardRef as ReactComponent };